import { useEffect, useState } from "react";
import { API } from "../lib/api";

export const AuthImage = ({ path, alt = "", className = "" }) => {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    if (!path) return;
    let objUrl;
    let active = true;
    const token = localStorage.getItem("token");
    fetch(`${API}/files/${path}`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => (r.ok ? r.blob() : Promise.reject()))
      .then((b) => { if (active) { objUrl = URL.createObjectURL(b); setSrc(objUrl); } })
      .catch(() => {});
    return () => { active = false; if (objUrl) URL.revokeObjectURL(objUrl); };
  }, [path]);
  if (!src) return <div className={`${className} bg-stone-100 animate-pulse`} />;
  return <img src={src} alt={alt} className={className} />;
};
